// React
import React, {useState} from "react";
// Redux imports
import { useSelector, useDispatch } from "react-redux";
import { setProyecto } from "../../../redux/reducers/proyectos";

import ActionBar, {
  Action,
  ActionGroup,
  // BottomActionGroup
} from 'calcite-react/ActionBar';

// Styled Components
import styled from "styled-components";

const ActionBarLeft = styled.div`
  // float:left;
  // display: inline-flex;
  // position: relative;
  // width: auto;
  // height: 100%;
  // text-align: center;
  // z-index: 2;
  // left: 0px;
  overflow: hidden;
  // background-color: #4c4c4c;
  // color: #fff;
`;

const ItemMenuOptsIcon = styled.div`
  width: 16px;
  height: 16px;
  background: transpararent;
  font-size:0.95rem;
  font-weight:700;
  text-align: center;
`;

const MenuLeftCompraEmpleabilidadFormacion = props => {
    // const isCollapsed = useSelector(state => state.proyectos.collapsed);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const activeAction = useSelector(state => state.proyectos.activeProyecto);
    const dispatch = useDispatch();

    const proyectosNames = {
      "":'Caracterización Social y Económica',
      "DESARROLLO_HERRAMIENTAS_SOCIALES_LABORALES": "Desarrollo de herramientas sociales y laborales",
      "ORIENTACION_VINCULACION_LABORAL": "Orientación para la vinculación laboral",
      "INGRESOS": "generación de ingresos",
      "CONFIGURACION": "Configuración del GRB", 
    };

    // useEffect(() => {
    //   dispatch(moduleLEFTPANELLoaded({activeModule:activeAction, headerTitle:proyectosNames[activeAction]}));
    // }, [dispatch]);

    const onToggleCollapse = (e) => {
      setIsCollapsed(!isCollapsed);
    };

    const turnOffModules = () => {
      // dispatch(moduleUSERSLoaded({loaded:false})); // Hide Users
      // dispatch(moduleBENEFICIARIOSLoaded({loaded:false}));
    }

    const actionSelected = (activeAction) => {
      dispatch(setProyecto({activeProyecto:activeAction, collapsed:isCollapsed, headerTitle:proyectosNames[activeAction]}));
      turnOffModules();
      switch (activeAction) {
        case 'DESARROLLO_HERRAMIENTAS_SOCIALES_LABORALES':
          console.log('DESARROLLO_HERRAMIENTAS_SOCIALES_LABORALES');
          break;
        case 'ORIENTACION_VINCULACION_LABORAL':
          console.log('ORIENTACION_VINCULACION_LABORAL');
          break;
        
        default:
          break;
      }
    };

    return (
      <ActionBarLeft>
      <ActionBar 
        // showCollapser={false}
        collapseLabel='Ocultar' 
        expandLabel='Expandir' 
        collapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      >
        <ActionGroup>
          <Action 
              onClick={() => actionSelected('DESARROLLO_HERRAMIENTAS_SOCIALES_LABORALES')}
              active={activeAction === 'DESARROLLO_HERRAMIENTAS_SOCIALES_LABORALES'}
              icon={<ItemMenuOptsIcon>D</ItemMenuOptsIcon>}
            >
              Desarrollo de herramientas sociales y laborales
          </Action>
          <Action
            onClick={() => actionSelected('ORIENTACION_VINCULACION_LABORAL')}
            active={activeAction === 'ORIENTACION_VINCULACION_LABORAL'}
            icon={<ItemMenuOptsIcon>O</ItemMenuOptsIcon>}
          >
            Orientación para la vinculación laboral
          </Action>
          
        </ActionGroup>
        {/* <BottomActionGroup>
        <Action icon={<GearIcon />}>Configuración</Action>
      </BottomActionGroup> */}
      </ActionBar>
      </ActionBarLeft>
    )

}

export default MenuLeftCompraEmpleabilidadFormacion;